import { Typography, Box, List, Button, CircularProgress } from '@mui/material';
import React, {useState} from 'react';
import { useParams, useOutletContext, useNavigate } from 'react-router-dom';
import AnswerReaction from './AnswerReaction';
import { questionStats } from '../../../fetching/fetchingUser';
import { toQuestionsView } from '../../../utils/routes';
import { useTranslation } from 'react-i18next';
import AnswerOption from './AnswerOption';

export default function Question(props) {

    let navigate = useNavigate();

    const {t, i18n} = useTranslation()

    let {quizpartId, subtopicId, activeQuestion} = useParams();

    // can be "correct", "partial_correct", "incorrect"
    const [correctAnswered, setCorrectAnswered] = useState("incorrect");
    const [answered, setAnswered] = useState(false);
    const [clickedAnswers, setClickedAnswers] = useState([]);

    const [questions] = useOutletContext();
    const id = questions[activeQuestion].id;
    const question = questions[activeQuestion].question[i18n.language];
    const clarification = questions[activeQuestion].explanation[i18n.language];
    const image = questions[activeQuestion].imageSrc;
    const answers = questions[activeQuestion].answers;

    const saveProgress = () => {
        props.updateQuizProgress(subtopicId);
    }

    const includesAnswer = (text) => {
        return clickedAnswers.find(v => v.text.de === text)
    }

    const options = () => {
        let optionItems = [];

        for (let answer of answers) {
            const translated_text = answer.text[i18n.language]
            optionItems.push(<AnswerOption includesAnswer={includesAnswer(answer.text["de"])} answer={answer}
                        handleAnswerClick={handleAnswerClick} key={translated_text} lang={i18n.language}
            />)
        }

        return optionItems;
    }

    const renderContent = () => {
        if (!answered) {
            return <Box sx={{display: "flex", flexDirection: "column"}}>
                <Typography align="center">
                    {question}
                </Typography>
                <Box>
                    {
                        image &&
                        <img src={image} alt="additional material to answer question" height={140}/>
                    }
                </Box>
                <List>
                    {options()}
                </List>
                <Button onClick={handleAnswering} color="primary" variant="contained">
                    {t("quizAnswerButton")}
                </Button>
            </Box>
        } else {
            return <AnswerReaction correct={correctAnswered} setAnswered={setAnswered} handleAnswer={handleAnswer}
                clarification={clarification} isLastQuestion={isLastQuestion}
            />
        }
    }

    const handleAnswerClick = (answer) => {
        if (!clickedAnswers.includes(answer)){
            setClickedAnswers([...clickedAnswers, answer]);
        } else {
            const arr = clickedAnswers.filter((item) => item !== answer);
            setClickedAnswers(arr);
        }
    }

    const handleAnswering = () => {
        const token = localStorage.getItem("jwt");
        
        setAnswered(true);

        let correctAnswers = answers.filter(val => val.correct).length;
        let wrongClickedAnswers = clickedAnswers.filter(val => !val.correct).length;
        let correctClickedAnswers = clickedAnswers.filter(val => val.correct).length;
        let correctness = getCorrectness(correctAnswers, wrongClickedAnswers, correctClickedAnswers)
        
        setCorrectAnswered(correctness);

        if (correctness === "correct") {
            questionStats(token, id, true);
            clearAnswers();
        } else if (correctness === "partial_correct"){
            questionStats(token, id, false);
        } else {
            questionStats(token, id, false);
            clearAnswers();
        }
    }

    const getCorrectness = (correctAnswers, wrongClickedAnswers, correctClickedAnswers) => {
        if(correctAnswers !== correctClickedAnswers && wrongClickedAnswers === 0) {
            return "partial_correct"
        } else if (correctAnswers === correctClickedAnswers && wrongClickedAnswers === 0) {
            return "correct"
        } else {
            return "wrong"
        }
    }

    const clearAnswers = () => {
        setClickedAnswers([]);
    }

    const isLastQuestion = parseInt(activeQuestion) === questions.length - 1;

    const handleAnswer = () => {
        if (!isLastQuestion) {
            const thisActiveQuestion = parseInt(activeQuestion) + 1;
            navigate(toQuestionsView(quizpartId, subtopicId, thisActiveQuestion))
        } else {
            saveProgress();
            navigate(toQuestionsView(quizpartId, subtopicId, "finished"))
        }
    }

    return(
        questions && questions[activeQuestion] ?
        <Box sx={{
            maxWidth: "400px",
            margin: "auto",
            marginTop: "2rem"
        }}>
            {renderContent()}
        </Box>
        :
        <CircularProgress/>
    )
}